import React, { Component } from "react";
import { Wrapper } from "app/NativeComponents/common";

import SideBarButton from "./SideBarButton";

class ListsButton extends Component {
  render() {
    if (this.props.user.team_clearance_level > 0) {
      return (
        <SideBarButton
          to="/app/messages"
          active={
            "messages" == this.props.tab || "messages" == this.props.tab
              ? true
              : false
          }
          dropParent={false}
          title="Messages"
          icon={"chat"}
          onPress={() => {
            this.props.changeTab("messages", this.props.tab);
            this.props.setActiveConversation({ conversation: null });
            this.props.appRedirect({ redirect: "message_engine" });
          }}
          hideButton={false}
          mobile_toggle_drawer={this.props.mobile_toggle_drawer}
          colors={this.props.colors}
          flag_title={this.props.platform == "ios" ? "New" : "Beta"}
        />
      );
    }

    return <Wrapper />;
  }
}

export default ListsButton;
